<template>
	<div class="home">
		<!--<div class="balls"></div>-->
		<HeaderGlobal
			:secondaryHeader="false"
			:qtSomos="qtSomos"
			:qtProjNumber="qtProjNumber"
			v-if="!popupPrivActive"
		/>
		<!-- Message If Error  -->
		<div v-if="!template && !processingApi" class="container">
			<h4 class="text-yellow extra-bold mt-5">
				{{ $t("error_loading_page") }}
			</h4>
			<p :class="defaultTextColor">
				{{ $t("try_again_later") }}
			</p>
		</div>
		<!-- Page Content Desktop  -->
		<div v-else-if="template && !popupPrivActive" class="container-fluid">
			<div
				class="container container-content border-left-light pt-3 pb-5 pt-md-5"
			>
				<div class="row">
					<div
						class="col-lg-7 pr-md-0 px-4 px-lg-5 mb-5 mb-lg-0 d-flex align-items-start"
					>
						<div class="pr-lg-5">
							<h1
								class="text-first-color extra-bold mb-4 max-w-sm"
								:class="[template.style.homeTitleSize ? 'title-style' : '']"
								style="white-space: pre-line"
								:style="template.style.homeTitleStyle"
							>
								{{ template.home.title }}
							</h1>
							<h4
								id="subtitle"
								v-if="template.home.subtitle"
								class="text-second-color max-w-sm mb-4"
								:class="{ 'subtitle-style': template.style.homeSubtitleSize }"
								style="white-space: pre-line"
								v-html="template.home.subtitle"
							></h4>
							<h4
								v-if="template.home.regulationHtmlSrc"
								class="text-first-color max-w-sm mb-4"
								:class="{ 'subtitle-style': template.style.homeSubtitleSize }"
							>
								<router-link
									to="/Regulation"
									tag="a"
									class="text-first-color c-intro underline"
								>
									{{ $t("click_for_draw_rules") }}
								</router-link>
							</h4>
							<article v-if="template.home.hashtag" class="mb-3 pt-2">
								<h5
									v-for="(item, index) in template.home.hashtag"
									:key="index"
									class="text-first-color"
								>
									{{ item }}
								</h5>
							</article>

							<div
								v-if="template.home.showPrevResult && surveyAtivo"
								class="pt-1"
							>
								<h4
									style="display: flex"
									class="mt-3 mb-4 text-second-color extra-bold"
								>
									{{ surveyAtivo ? "Participantes" : "Última votação:" }}
									<div class="loading-dots" style="margin-left: 20px">
										<span></span>
										<span></span>
										<span></span>
									</div>
								</h4>
								<div
									v-for="(item, index) in votingResult.answers"
									:key="index"
									style="color: white; width: 270px; height: 30px; margin-bottom: 3px"
								>
									<div v-if="index < 3">
										<img
											v-if="index == 0"
											style="height: 23px; margin-right: 8px"
											src="static/assets/img/gold.png"
										/>
										<img
											v-if="index == 1"
											style="height: 23px; margin-right: 8px"
											src="static/assets/img/prata.png"
										/>
										<img
											v-if="index == 2"
											style="height: 23px; margin-right: 8px"
											src="static/assets/img/bronze.png"
										/>
										{{ item.answer }} - {{ item.perc }}%
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						class="col-lg-4 pt-1 pl-4 pl-lg-5"
						v-if="surveyAtivo && !surveyType && !tokenWithError"
					>
						<h4
							id="intro"
							class="mt-3 mb-2 text-second-color extra-bold mt-lg-0 c-intro"
						>
							{{ template.home.intro }}
						</h4>
						<!-- Hide form when receive a token -->
						<div v-if="thereIsAToken">
							<h6 class="mt-0 text-second-color c-font-sm mb-4">
								{{ $t("verifying_your_info") }}
							</h6>
							<div class="text-center">
								<span
									v-if="processingApi"
									class="mx-auto spinner-border spinner-border-sm"
									:class="defaultTextColor"
									role="status"
									aria-hidden="true"
								></span>
							</div>
						</div>
						<!-- Form to login -->
						<div v-else>
							<h6 class="mt-0 text-second-color c-font-sm mb-4">
								{{ template.home.info }}
							</h6>
							<form @submit="checkForm" novalidate="false" id="homeForm">
								<vs-alert
									v-if="errors.length"
									class="mb-3 mt-2"
									:class="defaultTextColor"
									:active="inputInvalid"
								>
									<!--bf9f61-->
									<b>Por favor:</b>
									<ul class="common-list">
										<li v-for="error in errors" :key="error.questid">
											{{ error.msg }}
										</li>
									</ul>
								</vs-alert>
								<div class="col-md-12 px-0">
									<!-- user code -->
									<div
										v-if="!template.home.hideCpf"
										class="form-group my-4 my-md-0"
									>
										<label class="form-group has-float-label">
											<input
												type="text"
												:class="defaultTextColor"
												class="form-control form-control-home fcmobile"
												id="cpf"
												placeholder="XXX.XXX.XXX-XX"
												v-model="cpf"
												v-mask="'###.###.###-##'"
												@keyup="CheckCpfSurvey"
											/>
											<span :class="defaultTextColor" for="CPF"
												>{{ inviteName ? `CPF de ${inviteName}` : `CPF` }}
											</span>
										</label>
									</div>
									<div
										v-else-if="!template.home.hideEmail"
										class="form-group my-4 my-md-0"
									>
										<label class="form-group has-float-label">
											<input
												type="text"
												:class="defaultTextColor"
												class="form-control form-control-home fcmobile"
												id="email"
												placeholder="Email"
												v-model="email"
												@keyup="checkEmailSurvey"
											/>
											<span :class="defaultTextColor" for="email">{{
												$t("email")
											}}</span>
										</label>
									</div>
									<!-- end  -->
									<div
										v-if="!template.home.hidePhone"
										class="form-group my-4 my-md-0"
									>
										<label class="form-group has-float-label">
											<input
												type="tel"
												:class="defaultTextColor"
												class="form-control form-control-home fcmobile"
												id="telefone"
												placeholder="(xx) 9xxxx-xxxx"
												v-model="phone"
												v-mask="['(##) ####-####', '(##) #####-####']"
											/>
											<span :class="defaultTextColor" for="telefone">{{
												$t("cel")
											}}</span>
										</label>
									</div>
									<div
										class="my-4 my-md-0"
										v-if="
											!isTextTermsDefined ||
												(isTextTermsDefined && !template.terms.homeShowTerms)
										"
									>
										<label
											class="c-checkbox-container c-checkbox-container-home text-second-color c-font-sm"
										>
											<span class="c-font-sm">
												{{ !isTextTermsDefined ? $t("agree_with") : "" }}

												<router-link
													v-if="template.terms && template.terms.homeTextTerms"
													to="/terms"
													tag="a"
													class="text-second-color underline"
													:class="
														isTextTermsDefinedWithMoreThanTwoLine
															? 'text-decoration-none'
															: ''
													"
													>{{ template.terms.homeTextTerms[0] }}</router-link
												>

												<router-link
													v-if="
														!template.terms &&
															(!isTextTermsDefined ||
																isTextTermsDefinedWithMoreThanOneLine)
													"
													to="/terms"
													tag="a"
													class="text-second-color underline"
												></router-link>

												<router-link
													v-if="
														!isTextTermsDefined ||
															isTextTermsDefinedWithMoreThanOneLine
													"
													to="/terms"
													tag="a"
													class="text-second-color underline"
												>
													{{
														isTextTermsDefined
															? template.terms.homeTextTerms[1]
															: $t("terms_use_and_privacy")
													}}
												</router-link>
												<span
													v-if="
														!isTextTermsDefined ||
															isTextTermsDefinedWithMoreThanOneLine
													"
													class="c-font-sm"
												>
													{{
														isTextTermsDefined
															? template.terms.homeTextTerms[2]
															: $t("of_this_website")
													}}
												</span>
												<router-link
													v-if="
														!isTextTermsDefined ||
															isTextTermsDefinedWithMoreThanTwoLine
													"
													to="/Regulation"
													tag="a"
													class="text-second-color underline"
												>
													{{
														isTextTermsDefined
															? template.terms.homeTextTerms[3]
															: ""
													}}
												</router-link>
											</span>
											<input v-model="acceptTerms" type="checkbox" checked />
											<span class="checkmark checkmark-home mt-1"> </span>
										</label>
									</div>

									<span class="response" :class="defaultTextColor"></span>
									<button
										type="submit"
										class="btn btn-home btn-block mt-4 mb-2 btn-validate"
										ref="btnStart"
										:style="
											template.style.homeBtnColor
												? { backgroundColor: template.style.homeBtnColor }
												: ''
										"
										:disabled="processingApi"
									>
										{{ LabelBtn }}
										<span
											class="spinner-border spinner-border-sm"
											role="status"
											aria-hidden="true"
											v-if="processingApi"
										></span>
									</button>
								</div>
							</form>
						</div>
						<!-- Social Login -->

						<div class="mt-5" v-if="template.home.socialLogin">
							<div class="d-flex text-center">
								<div
									style="border-top: 1px solid white; width: 100%; margin-top: 1rem"
								></div>
								<h6
									class="mb-4 mx-2 text-center text-second-color c-font-sm w-100"
								>
									{{ template.home.socialTxt }}
								</h6>
								<div
									style="border-top: 1px solid white; width: 100%; margin-top: 1rem"
								></div>
							</div>
							<div class="justify-content-center d-flex">
								<button form="homeForm" class="fb btn btn-pill">
									<span title="Facebook">
										<i class="fa fa-facebook fa-fw"></i>
									</span>
								</button>
								<button form="homeForm" class="google btn btn-pill ml-2">
									<span title="Gmail">
										<i class="fa fa-google fa-fw"></i>
									</span>
								</button>
							</div>
						</div>
					</div>
					<div
						class="col-lg-4 pt-1 pl-4 pl-lg-5"
						v-if="!surveyAtivo && !surveyType"
					>
						<div class="lock-survey-div">
							<h4 class="mt-3 mb-2 text-second-color extra-bold">
								{{ msgInativo }}
							</h4>
							<img
								class="lock-survey-icon"
								:src="lockImg"
								alt="Ícone de cadeado"
							/>
						</div>

						<div v-if="template.home.showPrevResult" class="pt-1">
							<h4 class="mt-3 mb-4 text-second-color extra-bold">
								{{ surveyAtivo ? "Participantes:" : "Últimos participantes:" }}
							</h4>
							<div
								v-for="(item, index) in votingResult.answers"
								:key="index"
								style="color: white; width: 270px; height: 30px; margin-bottom: 15px"
							>
								<div v-if="index < 3">
									<img
										v-if="index == 0"
										style="height: 23px; margin-right: 8px"
										src="static/assets/img/gold.png"
									/>
									<img
										v-if="index == 1"
										style="height: 23px; margin-right: 8px"
										src="static/assets/img/prata.png"
									/>
									<img
										v-if="index == 2"
										style="height: 23px; margin-right: 8px"
										src="static/assets/img/bronze.png"
									/>
									{{ item.answer }} - {{ item.perc }}%
								</div>
							</div>
						</div>
					</div>

					<HomeType10
						class="col-lg-5 pt-1 pl-4"
						v-else-if="surveyType === '10'"
						:params="this.params"
						:id="this.template.survey.id"
						:prj="this.template.survey.prj"
						@clear-survey-type="clearSurveyType"
					/>

					<home-type12
						class="col-lg-5 pl-4"
						v-if="surveyType === '12'"
					></home-type12>
				</div>
			</div>
		</div>
		<FooterGlobal
			:secondaryFooter="false"
			:qtSomos="qtSomos"
			:qtProjNumber="qtProjNumber"
			v-if="!popupPrivActive"
		/>
		<!-- terms popup  -->
		<vs-popup
			class="popup popup-content-teste row"
			title="Termo de uso e política de privacidade"
			:active.sync="popupPrivActive"
		>
			<section class="row justify-content-center">
				<Termos class="col-12" :html="termosHtml"></Termos>
				<div class="col-11 absolute-bottom text-center">
					<button
						type="submit"
						class="btn btn-primary btnOption ml-3 mt-2 mb-4"
						v-on:click="acceptPriv"
					>
						Aceito
					</button>
				</div>
			</section>
		</vs-popup>
		<!-- checkIdentity popup  -->
		<vs-popup
			class="popup popup-content-teste row"
			:title="$t('confirm_identity')"
			:active.sync="openIdentityCheck"
		>
			<section class="d-flex flex-column justify-content-center px-5">
				<p class="h4">{{ this.popupValidationMessage }}</p>
				<!-- <label class="has-float-label my-2 pt-0"> -->
				<div class="mt-4">
					<span class="mb-2" for="telefone">{{ $t("birth_date") }}</span>
					<input
						ref="identityCheckInput"
						class="form-control form-group py-4 mb-1 form-control-home fcmobile"
						placeholder="dd/mm/aaaa"
						v-model="params.confirmationCode"
						v-mask="'##/##/####'"
						@keyup="resetErrorMessage"
						@keyup.enter="checkForm"
						:style="{
							borderColor:
								template.style && template.style.homeBtnColor
									? template.style.homeBtnColor
									: '',
						}"
					/>
				</div>
				<!-- </label> -->

				<p class="text-success" v-if="errorMessage.length">
					Dados de verificação incorretos - Entre em contato através do nosso
					WhatsApp:
					<a class="text-success" href="https://vozao.net/8530527777">
						85-3052-7777
						<img
							class="mt-n1"
							height="20px"
							src="static/assets/img/ic-wp.png"
							alt=""
						/>
					</a>
				</p>

				<button
					@click="checkForm"
					class="btn mt-4 mb-4 btn-validate"
					ref="btnStart"
					:style="
						homeSurveyBtnColor
							? {
									backgroundColor: homeSurveyBtnColor,
									color: templateFirstColor,
							  }
							: { backgroundColor: templateFirstColor }
					"
					:disabled="
						processingApi ||
							!params.confirmationCode ||
							(params.confirmationCode && params.confirmationCode.length < 10)
					"
				>
					{{ LabelBtn }}
					<span
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
						v-if="processingApi"
					></span>
				</button>
			</section>
		</vs-popup>
		<!-- Start Msg popup  -->
		<vs-popup
			class="row"
			:title="$t('system_message')"
			:active.sync="openPopupMsg"
		>
			<section class="d-flex flex-column justify-content-center px-5">
				<p class="h5">{{ $t("unable_to_complete_request") }}</p>
				<!-- </label> -->
				<p>
					{{ popupMsgTxt }}
				</p>

				<button
					@click="openPopupMsg = false"
					class="btn mt-4 mb-4 btn-validate"
					ref="btnClose"
					:style="
						homeSurveyBtnColor
							? { backgroundColor: homeSurveyBtnColor }
							: { backgroundColor: templateFirstColor }
					"
				>
					OK
					<span
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
						v-if="processingApi"
					></span>
				</button>
			</section>
		</vs-popup>
		<notifications group="foo" position="right bottom" width="300px" />
	</div>
</template>

<script>
import HeaderGlobal from "./HeaderGlobal.vue";
import FooterGlobal from "./FooterGlobal.vue";
import HomeType10 from "./HomeType10.vue";
import homeType12 from "@/components/HomeType12";
import Termos from "./Termos";

import { Survey } from "../services/Survey.js";
const s = new Survey();

import { utils } from "../services/Survey.js";
const u = new utils();

import { Fanbase } from "../services/Fanbase.js";
const f = new Fanbase();

import { mask } from "vue-the-mask";

export default {
	name: "Home",
	components: {
		HeaderGlobal,
		FooterGlobal,
		Termos,
		HomeType10,
		homeType12,
	},
	data: () => ({
		popupUseActive: false,
		popupPrivActive: false,
		processingApi: false,
		cpf: "",
		phone: "",
		errors: [],
		votingResult: [],
		qtErros: 0,
		surv: {},
		btnMes: "",
		started: false,
		termosHtml: "",
		acceptTerms: false,
		msgInativo: "",
		prjName: "",
		domainName: "",
		params: {},
		resultVoting: [],
		openIdentityCheck: false,
		errorMessage: "",
		email: "",
		identityFound: false,
		surveyType: false,
		openPopupMsg: false,
		popupMsgTxt: "",
		tokenWithError: false,
		popupValidationMessage: "",
	}),
	directives: { mask },
	async created() {
		this.btnMes = this.$t("be_part");
		this.getParams();
		await this.getTemplateByFullDomain();
	},
	mounted() {
		this.acceptTerms = this.$store.state.TermsAccepted;
		if (localStorage.cpf) {
			this.cpf = localStorage.cpf;
		}
		this.votingResult = {
			answers: [], // Simulação de dados
		};
		this.checkVotingResult();
	},
	watch: {
		cpf(newCpf) {
			if (newCpf.length === 14 && this.template) {
				this.CheckCpfSurvey();
			}
		},
		template() {
			this.btnMes = this.template.home.btnText;
			this.getDataHome();
			this.checkAuth();
			this.webChat();
			this.preResultVoting();
		},
		acceptTerms() {
			if (this.acceptTerms) {
				this.$store.commit("SET_TermsAccepted", true);
			} else {
				this.$store.commit("SET_TermsAccepted", false);
			}
		},
	},
	computed: {
		defaultTextColor() {
			return this.template.style && this.template.style.defaultTextColor
				? this.template.style.defaultTextColor
				: "text-white";
		},
		lockImg() {
			return this.template.style && this.template.style.defaultTextColor
				? "static/assets/img/lock-black.png"
				: "static/assets/img/lock.png";
		},
		thereIsAToken() {
			if (this.params.authToken && this.params.authToken.length) {
				return this.params.authToken;
			}
			return false;
		},
		isTextTermsDefined() {
			if (this.template.terms) {
				return this.template.terms.homeTextTerms;
			}
			return false;
		},
		isTextTermsDefinedWithMoreThanOneLine() {
			if (this.template.terms) {
				return (
					this.template.terms.homeTextTerms &&
					this.template.terms.homeTextTerms.length > 1
				);
			} else {
				return false;
			}
		},
		isTextTermsDefinedWithMoreThanTwoLine() {
			if (this.template.terms) {
				return (
					this.template.terms.homeTextTerms &&
					this.template.terms.homeTextTerms.length > 2
				);
			} else {
				return false;
			}
		},
		LabelBtn() {
			if (this.processingApi) return this.$t("wait");
			else return this.btnMes;
		},
		inputInvalid() {
			if (this.qtErros == 0) return false;
			else return true;
		},
		template() {
			if (Object.keys(this.$store.state.template).length) {
				return this.$store.state.template;
			}
			return false;
		},
		qtSomos() {
			return this.$store.state.qtUsers;
		},
		qtProjNumber() {
			return this.$store.state.qtProjNumber;
		},
		somosProjNumber() {
			return this.$store.state.somosProjNumber;
		},
		mustRegisterBefore() {
			if (
				this.template.registration &&
				this.template.registration.showRegistration
			) {
				return this.template.registration.showRegistration;
			}
			return false;
		},
		inviteName() {
			return this.$store.state.inviteName;
		},
		templateSurvey() {
			return this.$store.state.template.survey;
		},
		templateFirstColor() {
			return this.template.style && this.template.style.firstColor
				? this.template.style.firstColor
				: "";
		},
		homeSurveyBtnColor() {
			return this.template.style && this.template.style.surveyBtnColor
				? this.template.style.surveyBtnColor
				: "";
		},
		surveyAtivo() {
			return this.$store.state.surveyAtivo;
		},
		isAnAnonymousSurvey() {
			return (
				this.template.home.hideCpf &&
				this.template.home.hideEmail &&
				this.template.home.hidePhone
			);
		},
	},

	methods: {
		webChat() {
			if (this.template.home.showWebChat) {
				var script = document.createElement("script");
				script.src = this.template.home.webChatSrc;
				script.async = true;
				script.onerror = function() {
					console.error("Erro ao carregar o script vi_webchat.js");
				};
				document.body.appendChild(script);
			}
		},
		preResultVoting() {
			s.PrevResult(this.template.survey.id).then(
				(ret) => {
					let result = ret;
					this.$store.commit("SET_VotingResult", result.result[0]);
					this.votingResult = this.$store.state.votingResult;
				},
				(err) => {}
			);
		},
		checkVotingResult() {
			if (!this.votingResult || this.votingResult.answers.length === 0) {
				this.preResultVoting();
			}
		},
		checkAuth() {
			let authToken = this.getAuthToken();
			if (authToken) {
				this.$store.dispatch("set_isLoadingActive", true);
				s.Start(
					"",
					"",
					this.template.survey.id,
					this.template.survey.prj,
					this.params
				).then(
					(ret) => {
						this.$store.dispatch("set_isLoadingActive", false);
						this.$store.commit("SET_SurveyStruct", ret.surveyStruct);
						this.$store.commit("SET_Req", ret.currentReq);
						this.$store.commit("SET_Chapter", ret.currentChapter);
						this.$store.commit("SET_SurveyUserId", ret.userSurveyId);
						this.$store.commit("SET_UserId", this.cpf);
						this.$store.commit("SET_LastReq", ret.currentReq);

						if (ret.currentReq != 0) {
							this.$store.commit("SET_StarNextReq", true);
						}
						if (ret.answers) {
							for (var i = 0; i < ret.answers.length; i++) {
								var payload = {
									questid: ret.answers[i].id,
									value: ret.answers[i].value,
								};
								this.$store.commit("SET_Answer", payload);
							}
						}
						this.surv = ret;
						if (ret.checkIdentity) {
							this.openIdentityCheckPopup();
						} else {
							this.openIdentityCheck = false;
							if (
								ret.currentReq + ret.currentChapter === 0 &&
								this.template.beginSurvey.showBeginSurvey
							) {
								this.openIdentityCheck = false;
								this.removeTokenFromUrlParamsWithoutReloading();
								this.$router.push("beginsurvey");
							} else {
								this.openIdentityCheck = false;
								this.removeTokenFromUrlParamsWithoutReloading();
								this.$router.push("survey");
							}
						}
						this.processingApi = false;
					},
					(err) => {
						this.$store.dispatch("set_isLoadingActive", false);
						this.errorMessage = err;
						if (err.includes("Dados de verificação incorretos")) {
							this.openIdentityCheck = true;
						}

						if (err.includes("inválido")) {
							this.removeTokenFromUrlParamsWithoutReloading();
							this.tokenWithError = true;
							this.params = {};
							this.$vs.notify({
								color: "rgb(255, 130, 0)",
								title: `Recebemos um erro`,
								text: err,
								time: 11000,
							});
						} else {
							this.openPopupMsg = true;
							this.popupMsgTxt = err;
						}

						this.processingApi = false;
					}
				);
			}
		},
		getAuthToken() {
			if (!this.params.authToken || !this.params.authToken.length) return false;
			return this.params.authToken;
		},
		removeTokenFromUrlParamsWithoutReloading() {
			if (history.pushState) {
				const newurl =
					window.location.protocol +
					"//" +
					window.location.host +
					window.location.pathname;
				window.history.pushState({ path: newurl }, "", newurl);
			}
		},
		resetErrorMessage() {
			this.errorMessage = "";
		},
		setMetaDataFromTemplate() {
			document.title = this.template.meta.title;
			const descEl = document.querySelector('head meta[name="description"]');
			descEl.setAttribute("content", this.template.meta.desc);
			if (this.template.meta.favicon) {
				const favicon = document.querySelector("link[rel~='icon']");
				favicon.setAttribute("href", this.template.meta.favicon);
			}
		},
		setDocumentStylesFromTemplate() {
			if (this.template.style.fontFamilyP) {
				document.documentElement.style.setProperty(
					"--font-family-p",
					this.template.style.fontFamilyP
				);
			}
			if (this.template.style.fontFamilyH1) {
				document.documentElement.style.setProperty(
					"--font-family-h1",
					this.template.style.fontFamilyH1
				);
			}
			if (this.template.style.fontFamilyTitles) {
				document.documentElement.style.setProperty(
					"--font-family-titles",
					this.template.style.fontFamilyTitles
				);
			}
			if (this.template.style.fontFamilyGeneral) {
				document.documentElement.style.setProperty(
					"--font-family-general",
					this.template.style.fontFamilyGeneral
				);
			}
			document.documentElement.style.setProperty(
				"--first-color",
				this.template.style.firstColor
			);
			document.documentElement.style.setProperty(
				"--second-color",
				this.template.style.secondColor
			);
			document.documentElement.style.setProperty(
				"--survey-text-color",
				this.template.style.surveyTextColor
			);
			document.documentElement.style.setProperty(
				"--bg-image",
				this.template.style.bgImage
			);
			document.documentElement.style.setProperty(
				"--bg-gradient-color",
				this.template.style.bgGradientColor
			);
			document.documentElement.style.setProperty(
				"--bg-fallback-color",
				this.template.style.bgFallbackColor
			);
			document.documentElement.style.setProperty(
				"--bg-filter",
				this.template.style.bgFilter
			);
			document.documentElement.style.setProperty(
				"--btn-text-color",
				this.template.style.btnTextColor
			);
			document.documentElement.style.setProperty(
				"--home-title-size",
				this.template.style.homeTitleSize
			);
			document.documentElement.style.setProperty(
				"--home-title-height",
				this.template.style.homeTitleHeight
			);
			if (this.template.style.homeSubtitleSize) {
				document.documentElement.style.setProperty(
					"--home-subtitle-size",
					this.template.style.homeSubtitleSize
				);
			}
			if (this.template.style.homeSubtitleStyle) {
				document.documentElement.style.setProperty(
					"--home-subtitle-style",
					this.template.style.homeSubtitleStyle
				);
			}
			if (this.template.style.homeSubtitleHeight) {
				document.documentElement.style.setProperty(
					"--home-subtitle-height",
					this.template.style.homeSubtitleHeight
				);
			}
			if (this.template.style.surveyBtnTextColor) {
				document.documentElement.style.setProperty(
					"--btn-text-color-survey",
					this.template.style.surveyBtnTextColor
				);
			} else {
				document.documentElement.style.setProperty(
					"--btn-text-color-survey",
					this.template.style.btnTextColor
				);
			}
			if (this.template.style.surveyBtnColor) {
				document.documentElement.style.setProperty(
					"--btn-color",
					this.template.style.surveyBtnColor
				);
			} else {
				document.documentElement.style.setProperty(
					"--btn-color",
					this.template.style.firstColor
				);
			}
			document.documentElement.style.setProperty(
				"--bg-filter",
				this.template.style.bgFilter
			);
		},
		getRegulation() {
			u.getFileContentLoc(
				this.template.survey.prj,
				this.template.home.regulationHtmlSrc
			).then(
				(ret) => {
					if (ret) {
						this.$store.commit("SET_Regulation", ret);
					}
				},
				(err2) => alert(err2)
			);
		},
		async getTemplateByFullDomain() {
			this.processingApi = true;
			const fullDomain = window.location.host;
			try {
				await this.$store.dispatch("get_templateByFullDomain", { fullDomain });
			} catch (err) {
				await this.getTemplateBySubdomain();
			} finally {
				if (this.template) {
					if (this.template.home.regulationHtmlSrc) {
						this.getRegulation();
					}
					this.setMetaDataFromTemplate();
					this.setDocumentStylesFromTemplate();
				} else {
					document.documentElement.style.setProperty(
						"--bg-fallback-color",
						"#262626"
					);
				}
				if (this.cpf) {
					this.checkStarted();
				}
				this.processingApi = false;
			}
		},
		async getTemplateBySubdomain() {
			// get the prjName from subdomain
			if (this.$store.state.prjName) {
				this.prjName = this.$store.state.prjName;
				this.domainName = this.$store.state.domainName;
			} else {
				const host = window.location.host;
				const parts = host.split(".");

				if (host.includes("localhost")) {
					this.prjName = "nacaoalvinegra2";
					this.domainName = "fanbase";
				} else {
					if (host.endsWith(".br")) {
						if (parts[0] === "www") {
							this.prjName = "default";
							this.domainName = parts[1];
						} else if (parts.length === 4) {
							this.prjName = parts[0];
							this.domainName = parts[1];
						} else {
							this.prjName = "default";
							this.domainName = parts[0];
						}
					} else {
						if (parts[0] === "www") {
							this.prjName = "default";
							this.domainName = parts[1];
						} else if (parts.length === 3) {
							this.prjName = parts[0];
							this.domainName = parts[1];
						} else {
							this.prjName = "default";
							this.domainName = parts[0];
						}
					}
				}
				// get the prjTemplate from projName
				await this.$store.dispatch("get_PrjTemplate", {
					prj: this.prjName,
					domain: this.domainName,
				});
			}
		},
		hasTheDatePassed(date, time) {
			const [day, month, year] = date.split("/");
			const [hours, minutes] = time.split(":");

			const drawDate = new Date(
				`${year}-${month}-${day}T${hours}:${minutes}:00Z`
			);
			const currentDate = new Date();
			return drawDate < currentDate;
		},
		getDataHome() {
			f.GetData(this.template.survey.prj, this.template.survey.id).then(
				(ret) => {
					if (ret) {
						this.$store.commit("SET_QtUsers", ret.qt);
						this.$store.commit("SET_QtsomosProjNumber", ret.qtSurvey);
						this.$store.commit("SET_Project", ret.project);
						this.$store.commit(
							"SET_surveyAtivo",
							this.params.approv && this.templateSurvey.phase === "TEST"
								? true
								: ret.surveyActive
						);
						if (
							ret.prizeDrawn &&
							this.hasTheDatePassed(ret.drawDate, ret.drawTime)
						) {
							const payload = {
								drawDate: ret.drawDate,
								drawTime: ret.drawTime,
								winners: ret.winners,
							};
							this.$store.commit("SET_prizeDrawn", payload);
							this.surveyType = "12";
						}
						this.msgInativo = ret.surveyMsg;
						u.getFileContentLoc(this.template.survey.prj, "termos.html").then(
							(ret) => {
								if (ret) {
									this.termosHtml = ret;
									this.$store.commit("SET_Terms", ret);
								}
							},
							(err2) => alert(err2)
						);
					}
				},
				(err) => {
					let title = "Aviso";
					let text = "Ocorreu algum erro.\n " + err;
					if (!err.includes("Network Error")) {
						this.$vs.notify({
							color: "RGBA(255,0,0)",
							title,
							text,
							time: 5000,
						});
					}
				}
			);
		},
		getParams() {
			this.params = Object.fromEntries(
				new URLSearchParams(window.location.search)
			);
			this.surveyType = this.params.st;
		},
		clearSurveyType() {
			this.surveyType = false;
		},
		acceptUse() {
			this.popupUseActive = false;
			this.popupPrivActive = true;
		},
		acceptPriv() {
			this.$store.commit("SET_TermsAccepted", true);
			this.acceptTerms = true;

			this.popupPrivActive = false;
			this.submit();
		},
		declineUse() {
			this.$store.commit("SET_TermsAccepted", false);
			this.acceptTerms = false;
			this.popupUseActive = false;
		},
		declinePriv() {
			this.$store.commit("SET_TermsAccepted", false);
			this.acceptTerms = false;
			this.popupPrivActive = false;
		},
		ErrorOccured(value, id) {
			var payload = { questid: id, msg: value };
			if (this.errors) {
				var found = false;
				for (var i = 0; i < this.errors.length; i++) {
					if (this.errors[i].questid == id) {
						this.errors[i] = payload;
						found = true;
					}
				}
				if (!found) {
					this.errors.push(payload);
					this.qtErros++;
				}
			} else {
				this.qtErros++;
				this.errors.push(payload);
			}
		},
		RemoveError(id) {
			if (this.errors)
				for (var i = 0; i < this.errors.length; i++) {
					if (this.errors[i].questid == id) {
						this.errors.splice(i, 1);
						this.qtErros--;
					}
				}

			if (this.errors.length == 0) {
				this.errors = [];
				this.qtErros = 0;
			}
		},
		CheckCpfSurvey() {
			if (this.TestaCPF(this.cpf) && this.template) {
				localStorage.cpf = this.cpf;
				//Verificar se já iniciou survey
				this.checkStarted();
			} else {
				this.btnMes = this.template.home.btnText;
			}
		},
		checkEmailSurvey() {
			if (this.checkEmail(this.email)) {
				this.checkStarted();
			} else {
				this.btnMes = this.template.home.btnText;
			}
		},
		checkStarted() {
			this.processingApi = true;
			let code = "";
			let codeType = null;
			if (this.template.home && this.template.home.useEmail) {
				code = this.email;
				codeType = 4;
			} else {
				code = this.cpf;
				codeType = 1;
			}
			s.CheckStart(
				this.template.survey.id,
				this.template.survey.prj,
				"",
				code,
				codeType
			).then(
				(ret) => {
					this.identityFound = !!ret.identity;
					if (ret.surveyUserId) {
						this.btnMes = this.$t("continue_where_left");
						this.$store.commit("SET_TermsAccepted", false);
						this.acceptTerms = false;
						this.errors = [];
						this.processingApi = false;
						if (!this.template.home.useEmail) {
							this.$refs["btnStart"].focus();
						}
					} else {
						this.phone = "";
						this.processingApi = false;
						this.btnMes = this.template.home.btnText;
					}
				},
				(err) => {
					this.$vs.notify({
						color: "RGBA(255,0,0)",
						title: this.$t("problem_ocurred"),
						text: this.$t("error_verifying_survey_start") + err,
						time: 5000,
					});
					this.tokenWithError = true;
					this.processingApi = false;
				}
			);
		},
		checkForm: function(e) {
			this.errors = [];
			if (!this.thereIsAToken) {
				if (this.template.home.useEmail) {
					let valid = this.checkEmail(this.email);
					if (!valid) {
						this.ErrorOccured("Email Inválido", 1);
					}
				}
				if (!this.template.home.hideCpf && !this.TestaCPF(this.cpf)) {
					this.ErrorOccured("Verifique, CPF informado Inválido", 1);
				} else if (!this.phone && !this.template.home.hidePhone)
					this.ErrorOccured("Informe seu número de celular.", 2);
				else if (!this.acceptTerms) {
					this.ErrorOccured(this.$t("agree_terms_use_and_privacy"), 3);
				}
			}

			if (!this.errors.length) {
				if (
					!this.$store.state.TermsAccepted &&
					this.isTextTermsDefined &&
					this.template.terms.homeShowTerms
				) {
					window.scrollTo(0, 0);
					this.popupPrivActive = true;
				} else {
					this.submit();
				}
			}
			e.preventDefault();
		},

		checkEmail: function(rg) {
			var rgRegex = /\S+@\S+\.\S+/;
			if (rgRegex.test(rg)) {
				return true;
			} else {
				return false;
			}
		},

		TestaCPF: function(strCPF) {
			if (!strCPF || !strCPF.length) return false;
			var Soma;
			var Resto;
			Soma = 0;
			strCPF = strCPF.replace(/[^\d]/g, "");
			if (strCPF == "00000000000") return false;
			if (strCPF == "11111111111") return false;
			if (strCPF == "22222222222") return false;
			if (strCPF == "33333333333") return false;
			if (strCPF == "44444444444") return false;
			if (strCPF == "55555555555") return false;
			if (strCPF == "66666666666") return false;
			if (strCPF == "77777777777") return false;
			if (strCPF == "88888888888") return false;
			if (strCPF == "99999999999") return false;
			var i;
			for (i = 1; i <= 9; i++)
				Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
			Resto = (Soma * 10) % 11;

			if (Resto == 10 || Resto == 11) Resto = 0;
			if (Resto != parseInt(strCPF.substring(9, 10))) return false;

			Soma = 0;
			for (i = 1; i <= 10; i++)
				Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
			Resto = (Soma * 10) % 11;

			if (Resto == 10 || Resto == 11) Resto = 0;
			if (Resto != parseInt(strCPF.substring(10, 11))) return false;
			return true;
		},

		openIdentityCheckPopup() {
			delete this.params.confirmationCode;
			this.openIdentityCheck = true;
			this.$nextTick(() => {
				this.$refs.identityCheckInput.focus();
			});
		},

		submit() {
			this.processingApi = true;
			this.openIdentityCheck = false;
			this.resetErrorMessage();
			let code = "";
			if (this.isAnAnonymousSurvey) code = "";
			else if (this.template.home.useEmail) code = this.email;
			else code = this.cpf;
			if (this.mustRegisterBefore && !this.identityFound) {
				this.$store.commit("SET_RegistrationCode", code);
				this.$router.push("beginRegister");
				this.processingApi = false;
				return;
			}
			s.Start(
				code,
				this.phone,
				this.template.survey.id,
				this.template.survey.prj,
				this.params
			).then(
				(ret) => {
					this.popupValidationMessage = ret.msg
						? ret.msg
						: this.$t("confirm_identity");
					this.$store.commit("SET_SurveyStruct", ret.surveyStruct);
					this.$store.commit("SET_Req", ret.currentReq);
					this.$store.commit("SET_Chapter", ret.currentChapter);
					this.$store.commit("SET_SurveyUserId", ret.userSurveyId);
					this.$store.commit("SET_UserId", this.cpf);
					this.$store.commit("SET_LastReq", ret.currentReq);
					if (ret.currentReq != 0) {
						this.$store.commit("SET_StarNextReq", true);
					}

					//adicionar as respostas
					if (ret.answers) {
						for (var i = 0; i < ret.answers.length; i++) {
							var payload = {
								questid: ret.answers[i].id,
								value: ret.answers[i].value,
							};
							this.$store.commit("SET_Answer", payload);
						}
					}

					this.surv = ret;

					if (ret.checkIdentity) {
						this.openIdentityCheckPopup();
					} else {
						this.openIdentityCheck = false;
						if (
							ret.currentReq + ret.currentChapter === 0 &&
							this.template.beginSurvey.showBeginSurvey
						) {
							this.openIdentityCheck = false;
							this.$router.push("beginsurvey");
						} else if (ret.surveyEnded) {
							this.$router.push("finalSurvey");
						} else {
							this.openIdentityCheck = false;
							this.$router.push("survey");
						}
					}
					this.processingApi = false;
				},
				(err) => {
					this.errorMessage = err;
					if (err.includes("Dados de verificação incorretos")) {
						this.openIdentityCheckPopup();
					} else if (err.includes("Não autorizado")) {
						this.$vs.notify({
							color: "RGBA(255,0,0)",
							title: `Aviso!`,
							text: "Você não foi autorizado.",
							time: 5000,
						});
					} else {
						this.openPopupMsg = true;
						this.popupMsgTxt = err;
					}
					this.processingApi = false;
				}
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.max-w-sm {
	max-width: 515px;
}
.loading-dots {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 5px;
}

.loading-dots span {
	width: 8px;
	height: 8px;
	background-color: white;
	border-radius: 50%;
	animation: blink 1.2s infinite;
}

.loading-dots span:nth-child(1) {
	animation-delay: 0s;
}

.loading-dots span:nth-child(2) {
	animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
	animation-delay: 0.4s;
}

@keyframes blink {
	0%,
	80%,
	100% {
		opacity: 0;
	}
	40% {
		opacity: 1;
	}
}
.subtitle-style {
	font-size: var(--home-subtitle-size) !important;
	line-height: var(--home-subtitle-height) !important;
	text-align: var(--home-subtitle-style) !important;
}
.title-style {
	font-size: var(--home-title-size) !important;
	line-height: var(--home-title-height) !important;
	text-align: var(--home-subtitle-style) !important;
	@media (max-width: 767px) {
		text-align: var(--home-subtitle-style) !important;
		font-size: calc(var(--home-title-size) / 1.5) !important;
		line-height: var(--home-title-height) !important;
	}
}
@media screen and (min-width: 1200px) {
	.c-intro {
		font-size: 1.25rem !important;
	}
	#subtitle {
		font-weight: 400 !important;
		font-family: var(--font-family-p), serif;
	}
}

.fb {
	background-color: #3b5998;
	color: white;
	border-color: #3b5998;
}
.fb:hover {
	background-color: rgba(59, 89, 152, 0.7);
	color: rgba(255, 255, 255, 0.7);
}
.google {
	background-color: #dd4b39;
	color: white;
	border-color: #dd4b39;
}
.google:hover {
	background-color: rgba(221, 75, 57, 0.7);
	color: rgba(255, 255, 255, 0.7);
}

.btn-pill {
	padding: 0.5rem;
	border-radius: 100%;
}
.c-font-sm {
	font-size: 0.8rem;
	line-height: 1.2;
}

.lock-survey-div {
	display: flex;
}

.lock-survey-icon {
	height: 25px;
	margin-top: 17px;
	margin-left: 10px;
}

.underline {
	text-decoration: underline;
}
</style>
